import { render, staticRenderFns } from "./banner_logo.vue?vue&type=template&id=3e318a6c&"
import script from "./banner_logo.vue?vue&type=script&lang=js&"
export * from "./banner_logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports